export default __webpack_public_path__ + "static/header-signup-mobile-76481015052fc707a2c2caa7741ec021.jpg";